/**
 *  全站共用資料
 */
import { queryApiDoc } from "@/api/init.js";
import { ENV } from '@/enum/global';
import { mapMutations, mapGetters } from 'vuex';
import { surveyRequired } from "@/api/users.js";

export const initGlobalData = {
  methods: {
    ...mapMutations({
      setEnv: 'setting/setEnv',
      setNextLink: 'setting/setNextLink',
      setLogoutLink: 'setting/setLogoutLink',
      setBaseLink: 'setting/setBaseLink',
      setPAUserCenterLink: 'setting/setPAUserCenterLink',
    }),
    /**
     * 取得全站版本環境資料
     */
    async queryApiDoc(init = () => { }) {
      try {
        init();
        let tempData = await queryApiDoc(); //api 版本環境

        const data = tempData.data;
        await this.setEnvInfo(data.environment);
      } catch (err) {
        console.log('api doc error', err);
      }
    },
    setEnvInfo(env) {
      const _env = env;
      this.setEnv(_env);
      let link = '';
      let baseLink = '';
      let paUserCenterLink = '';
      const host = window.location.host;
      let nextLink = '';
      const orgLocation = window.location;
      let hostLink = '';
      switch (_env) {
        case ENV.DEV:
          link = `/pa4itp/auth/login/`;
          hostLink = `http://${host}` + link;
          baseLink = `http://${host}` + `/home/#`;
          nextLink = hostLink;
          paUserCenterLink = 'https://orderqc.asus.com/pp-dev/member/m/profile/info';
          break;
        case ENV.STAGING:
          hostLink = "https://bpza003kjc.corpnet.asus";
          link = hostLink + "/pa4itp/auth/login/";
          baseLink = hostLink + "/home/#";
          nextLink = link;
          paUserCenterLink = 'https://orderqc.asus.com/pp-dev/member/m/profile/info';
          break;
        case ENV.PRODUCTION:
          //logout
          hostLink = "https://partner-portal.asus.com/start";
          //403
          link = "https://commercialservice.asus.com/pa4itp/auth/login/pa/?";
          //user center
          baseLink = 'https://commercialservice.asus.com/home/#';
          nextLink = link + "next=" + encodeURIComponent(orgLocation.pathname + orgLocation.hash);
          paUserCenterLink = 'https://partner-portal.asus.com/member/m/profile/info';
          break;
        case ENV.UAT:
          hostLink = "https://partner-portal-beta.asus.com/start";
          link = "https://commercialservice.asus.com/pa4itp-uat/auth/login/pa/?";
          baseLink = 'https://commercialservice.asus.com/home-uat/#';
          nextLink = link + "next=" + encodeURIComponent(orgLocation.pathname + orgLocation.hash);
          paUserCenterLink = 'https://partner-portal-beta.asus.com/member/m/profile/info';
          break;
        default:
          link = `/pa4itp/auth/login/`;
          hostLink = "https://bpza003kjc.corpnet.asus:8021/pa4itp/auth/login/";
          baseLink = `https://bpza003kjc.corpnet.asus:8021/home/#`;
          nextLink = "https://bpza003kjc.corpnet.asus:8021/pa4itp/auth/login/";
          paUserCenterLink = 'https://orderqc.asus.com/pp-dev/member/m/profile/info';
          break;
      }
      this.setLogoutLink(hostLink);
      this.setNextLink(nextLink);
      this.setBaseLink(baseLink);
      this.setPAUserCenterLink(paUserCenterLink);
    }
  }
};

export const npsSetting = {
  data() { },
  computed: {
    ...mapGetters({
      getIsSurveyRequired: "user/getIsSurveyRequired"
    })
  },
  methods: {
    ...mapMutations({
      setSurveyRequired: "user/setSurveyRequired", // show modal
      setHasSurvey: "user/setHasSurvey"
    }),
    /**
     * 設定nps
     */
    async isSurveyRequired(justCheck) {
      try {
        let isSurveyNeed = false;
        const { data } = await surveyRequired();
        // console.log('justCheck',justCheck,data.survey_required)
        this.setHasSurvey(data.survey_required);
        if (data.survey_required) {
          if (justCheck) {
            //只是確認，不設定任何東西
            isSurveyNeed = true;
          } else {
            //方法一
            let a = JSON.parse(localStorage.getItem("closeNps"));

            if (!a) {
              this.setSurveyRequired(data.survey_required);
            }
            //方法一
          }
        } else {
          isSurveyNeed = false;
        }
        console.log("globe setSurveyRequired", data);
        return isSurveyNeed;
      } catch (error) {
        this.apiError = error.response.status;
      }
    }
  }
};